import { useCallback, useEffect, useState } from "react";
import { CalendarDays, Clock3, Settings2, Users } from "lucide-react";
export type PortalTab = "today" | "calendar" | "clients" | "mypage";
export function usePortalTab() {
  const read = (): PortalTab => {
    const value = new URLSearchParams(window.location.search).get("tab");
    return value === "calendar" || value === "clients" || value === "mypage" ? value : "today";
  };
  const [tab, setTab] = useState<PortalTab>(read);
  useEffect(() => {
    const update = () => setTab(read());
    window.addEventListener("popstate", update);
    return () => window.removeEventListener("popstate", update);
  }, []);
  const change=useCallback((next: PortalTab) => {
    const url = new URL(window.location.href);
    url.searchParams.set("tab", next);
    window.history.pushState({}, "", url);
    setTab(next);
    window.scrollTo({ top: 0 });
  },[]);
  return [tab,change] as const;
}
export function PortalShell({ tab, onChange }: { tab: PortalTab; onChange: (tab: PortalTab) => void }) {
  const [editing, setEditing] = useState(false);
  useEffect(() => {
    const update = () => setEditing(document.activeElement instanceof HTMLElement && document.activeElement.matches("input:not([type=checkbox]):not([type=radio]),textarea,select"));
    document.addEventListener("focusin", update);
    document.addEventListener("focusout", update);
    return () => { document.removeEventListener("focusin", update); document.removeEventListener("focusout", update); };
  }, []);
  return <nav className="portal-nav" aria-label="내 예약실" hidden={editing}>
    {([ ["today", "오늘", Clock3], ["calendar", "달력", CalendarDays], ["clients", "고객", Users], ["mypage", "내 페이지", Settings2] ] as const).map(([id, label, Icon]) => <button key={id} type="button" aria-current={tab === id ? "page" : undefined} onClick={() => onChange(id)}><Icon aria-hidden="true" />{label}</button>)}
  </nav>;
}
